<template>
  <div v-if="content" v-editable="content" id="seminaires" class="bg-gray-100 overflow-hidden">
    <component class="content-width mx-auto" :content="blok" :key="blok._uid" v-for="(blok) in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";
import { gsap } from "gsap";
export default {
  data() {
    return {
      content: null,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    setTimeout(() => {
      gsap.from(".simple-card", {
        duration: 1,
        opacity: 0,
        stagger: {
          amount: 1,
        },
      });
    }, 1);
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get(
          `cdn/stories/${this.$i18n.locale}/pages/seminaires-cav`
        );
        this.content = res.data.story.content;
      } catch (err) {
        this.$router.push("/404");
      }
    },
  },
};
</script>

<style lang="scss">
</style>
